// OP-3619 — Anexar pela câmera ou por arquivo, e já enviar.
//
// No celular, "Tirar foto" abre a câmera traseira e a foto sobe assim que é
// tirada: quem despacha ou entrega a remessa está com o papel na mão, e o
// passo de escolher o arquivo e depois tocar em Enviar era onde o comprovante
// ficava para trás. Arquivo (PDF, galeria) segue o mesmo caminho. A foto
// desfocada se refaz na própria câmera do celular, que pede confirmação antes
// de devolver o arquivo.
import { ChangeEvent, FC, useRef, useState } from 'react'
import { Button } from '../styles'
import { IconeCamera } from './CampoComLeitor'
import { comprimirFoto } from './foto'
import { eTelaDeToque } from './leitura'

export interface AnexarArquivoProps {
  aoEnviar: (arquivo: File) => void | Promise<unknown>
  disabled?: boolean
  aceita?: string
}

export const AnexarArquivo: FC<AnexarArquivoProps> = ({ aoEnviar, disabled, aceita = 'image/*,application/pdf' }) => {
  const [comCamera] = useState(eTelaDeToque)
  const [preparando, setPreparando] = useState(false)
  const foto = useRef<HTMLInputElement>(null)
  const arquivo = useRef<HTMLInputElement>(null)

  const escolhido = async (e: ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files?.[0]
    e.target.value = ''
    if (!f) return
    setPreparando(true)
    try {
      const pronto = await comprimirFoto(f)
      await aoEnviar(pronto)
    } finally {
      setPreparando(false)
    }
  }

  const bloqueado = disabled || preparando
  return (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
      {comCamera && (
        <>
          <input ref={foto} type="file" accept="image/*" capture="environment" hidden onChange={escolhido} />
          <Button type="button" disabled={bloqueado} onClick={() => foto.current?.click()}
                  style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
            <IconeCamera />Tirar foto
          </Button>
        </>
      )}
      <input ref={arquivo} type="file" accept={aceita} hidden onChange={escolhido} />
      <Button type="button" $variant="secondary" disabled={bloqueado} onClick={() => arquivo.current?.click()}>Escolher arquivo</Button>
      {preparando && <span style={{ fontSize: 13 }}>Enviando…</span>}
    </div>
  )
}

export default AnexarArquivo
